import React, { useEffect, useState } from 'react'
import { END_POINTS, RequestData } from '../utils/apiService'

const Deliveryratings = ({ shipmentDetails, isEditable = true, initialRating = 0, initialFeedback = '' }) => {
  const stars = [1, 2, 3, 4, 5];
  const [rating, setRating] = useState(initialRating);
  const [feedback, setFeedback] = useState(initialFeedback);
  const [hover, setHover] = useState(0);
  const [feedbackTags, setFeedbackTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const compnentStyle = `
    .seCard {
        border: 1px solid #E0E0E0;
        border-radius: 8px;
        padding: 16px;
        max-width: 400px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      
      .seCardHeader {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }
      
      .seCardIconStatus img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
      
      .seCardTitle {
        font-size: 18px;
        font-weight: bold;
      }
      
      .seRatingBody {
        // text-align: center;
      }
      .seTextCenter {
        text-align: center;
      }
      
      .seRatingStars {
        display: flex;
        justify-content: center;
        margin: 16px 0;
      }

      .seRatingStarsNoEditing {
        display: flex;
        justify-content: center;
        margin: 16px 0;
        gap: 4px;
      }
      
      .seRatingStar {
        cursor: pointer;
        margin: 0 4px;
        transition: transform 0.2s;
      }
      
      .seRatingStarFilled svg path {
        fill: #328616;
        stroke: #DCFCE7;
      }
      
      .seRatingStar:hover {
        transform: scale(1.2);
      }

      .seRatingStarsNoEditing .seRatingStar {
        cursor: default;
        transform: none;
      }

      .seRatingStarsNoEditing .seRatingStar:hover {
        transform: none;
      }

      .seRatingStarsNoEditing .seRatingStar svg {
        width: 35px;
        height: 35px;
      }
      
      .seRatingFeedbackLabel {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        color: rgb(51, 51, 51);
      }
      .seRatingFeedback {
        width: 100%;
        padding: 8px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        resize: vertical;
        margin-bottom: 16px;
        border-radius: 10px;
        padding: 10px;
      }
      
      .seRatingButton {
        background-color: #328616;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        display: flex;
        justify-content: center;
        width: 100%;
      }
      
      .seRatingButton:disabled {
        // color: #9CA3AF;
        background-color: #E0E0E0;
        cursor: not-allowed;
      }
      
      .seRatingSubtitle {
        font-size: 16px;
        margin-bottom: 8px;
      }

      .sefeedback-tags-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 16px 0;
        // justify-content: center;
      }

      .sefeedback-tag {
        padding: 6px 12px;
        border: 1px solid #E0E0E0;
        border-radius: 20px;
        // background-color: #F5F5F5;
        cursor: pointer;
        font-size: 13px;
        transition: all 0.2s;
        user-select: none;
      }

      .sefeedback-tag:hover {
        background-color: #E0E0E0;
      }

      .sefeedback-tag.selected {
        background-color: #328616;
        color: white;
        border-color: #328616;
      }

      .sefeedback-tags-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 8px;
        // text-align: center;
      }

        /* seLoader styles */
      .seloader {
        width: 20px;
        height: 20px;
        border: 2px solid #FFF;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      `

  const submitRating = async (rating, feedback = '', tags = []) => {
    setIsSubmitting(true);
    const requestBody = {
      shipment_id: shipmentDetails?._id || '',
      feedback: {
        rating: rating,
        notes: feedback,
        tags: tags
      }
    }

    RequestData(END_POINTS?.FEEDBACK_URL, 'POST', requestBody).then((response) => {
      if (response?.status) {
        window.location.reload();
      }
    }).catch((error) => {
      console.log('Error submitting rating:', error);
    })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  const handleTagClick = (tagValue) => {
    if (selectedTags.includes(tagValue)) {
      setSelectedTags(selectedTags.filter(tag => tag !== tagValue));
    } else {
      setSelectedTags([...selectedTags, tagValue]);
    }
  }

  useEffect(() => {
    RequestData(END_POINTS?.FEEBCACK_TAGS).then((response) => {
      if (response?.status) {
        setFeedbackTags(response?.data || []);
      }
    }).catch((error) => { })
  }, [])

  const showFeedbackTags = isEditable && rating > 0 && rating < 5;
  const displayValue = hover || rating;

  return (<>
    <style>{compnentStyle}</style>
    <div className="seCard">
      <div className="seCardHeader">
        <span className="seCardIconStatus" role="img" aria-label="stars and thumbs up">
          <img src={"https://localdelivery.s3.ap-south-1.amazonaws.com/assests/tracking/Icons/rateyourdelivery.png"} alt="stars and thumbs up" />
        </span>
        <span className="seCardTitle">Rate Your Delivery</span>
      </div>

      <div className="seRatingBody">
        {<div className="seRatingSubtitle seTextCenter">{!isEditable ? "Thank you for your valuable feedback" : "How was your experience with this delivery?"}</div>}

        <div className={isEditable ? "seRatingStars" : "seRatingStarsNoEditing"}>
          {stars.map((star) => (
            <span
              key={star}
              className={`seRatingStar${displayValue >= star ? ' seRatingStarFilled' : ''}`}
              onMouseEnter={() => isEditable && setHover(star)}
              onMouseLeave={() => isEditable && setHover(0)}
              onClick={isEditable ? () => {
                setRating(star);
                if (star >= 5) {
                  setSelectedTags([]);
                }
              } : undefined}
              role={isEditable ? "button" : undefined}
              tabIndex={isEditable ? 0 : -1}
              aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
            >
              <svg width="35" height="35" viewBox="0 0 48 48" fill="none">
                <path
                  d="M24 36l-13.09 7.36 3.5-14.36L2 18.64l14.45-1.23L24 4l7.55 13.41L46 18.64l-12.41 10.36 3.5 14.36z"
                  stroke="#BDBDBD"
                  strokeWidth="2"
                  fill={displayValue >= star ? '#328616' : 'none'}
                />
              </svg>
            </span>
          ))}
        </div>

        {showFeedbackTags && feedbackTags.length > 0 && (
          <>
            <div className="seRatingFeedbackLabel">What went wrong?</div>
            <div className="sefeedback-tags-container">
              {feedbackTags.map((tag) => (
                <div
                  key={tag.value}
                  className={`sefeedback-tag ${selectedTags.includes(tag.value) ? 'selected' : ''}`}
                  onClick={() => handleTagClick(tag.value)}
                >
                  {tag.label}
                </div>
              ))}
            </div>
          </>
        )}

        {isEditable && rating ? (<>
          <label htmlFor='feedback' className='seRatingFeedbackLabel'>{rating < 5 && rating != 0 ? "Please add a brief note on the issue to help us become better. (optional)" : "Please leave your feedback here. (optional)"}</label>
          <textarea
            id='feedback'
            value={feedback}
            onChange={(event) => setFeedback(event.target.value)}
            className="seRatingFeedback"
            placeholder={"Please leave your feedback here."}
            rows={3}
          />
        </>) : (
          <div style={{ color: '#6b7280', textAlign: 'center' }}>{feedback}</div>
        )}

        {isEditable && (
          <button
            className="seRatingButton"
            onClick={() => !isSubmitting && submitRating(rating, feedback, selectedTags)}
            disabled={rating === 0 || isSubmitting || (showFeedbackTags && feedbackTags.length > 0 && selectedTags.length === 0)}
          >
            {isSubmitting ? (
              <>
                <span className="seloader"></span>
                {/* <span>Submitting...</span> */}
              </>
            ) : (
              "Submit"
            )}
          </button>
        )}
      </div>
    </div>
  </>)
}

export default Deliveryratings